
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class HistoricalChartButtonComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.base.tiChartSeries?.subscribeExtremeChange(() => {
            this.setPosition();
            this.toggleButton()
        });

        this.onClick();
        this.onResize();
    }

    private setPosition() {
        if (!this.base.tiChartSeries) {
            return;
        }

        const xAxis: any =  this.base.tiChartSeries.highStockChart?.xAxis[0];
        if (!xAxis) {
            return;
        }
        
        let extraTop = 10 + (this.base.tiChartSeries.hasAnyComparisonSymbols() ? 20 : 0);
        if (this.base.pnpMode) {
            if (this.base.marketingWebChartMode) {
                extraTop -= 5;
            } else {
                extraTop -= 30;
            }
        }
        
        const top = xAxis.height + extraTop;
        let left = xAxis.width - 20;
        if (this.base.marketingWebChartMode && !this.base.pnpMode) {
            // left = xAxis.width - 80;
            left = xAxis.width - 15;
        }

        this.element.style.top = top + 'px';
        this.element.style.left = left + 'px';
    }
    
    private onClick() {
        this.element.addEventListener('click', () => {
            if (!this.base.tiChartSeries) {
                return;
            }

            this.base.tiChartSeries.extreamMin = this.base.tiChartSeries.originalMinimumXValueWithZoom;
            this.base.tiChartSeries.extreamMax = this.base.tiChartSeries.originalMaximumXValue;
            this.base.tiChartSeries?.highStockChart.xAxis[0]?.setExtremes(this.base.tiChartSeries.extreamMin, this.base.tiChartSeries.extreamMax, true, false);
            setTimeout(() => {
                this.base.tiChartSeries?.highChartAxisBuilder.buildAxisComponents();
            }, 50);
        });
    }

    private toggleButton() {
        setTimeout(() => {
            if (!this.base.tiChartSeries) {
                return;
            }
    
            if (this.base.tiChartSeries.isCurrentBarVisible()) {
                this.element.addClass('hidden');
            } else {
                this.element.removeClass('hidden');
            }
        }, 150);
    }

    private onResize() {
        this.base.domEvents.onResize(() => {
            this.setPosition();
        });
    }
}